import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useFontSize } from '../../context/FontSizeContext';
import { useQRCode } from '../../context/QRCodeContext';
import { useNavigate } from 'react-router-dom';
import './LoginDropdown.css';

export const LoginDropdown = ({ isOpen, onClose }) => {
  const { currentUser, isAdmin, login, logout } = useAuth();
  const { openModal: openFontSizeModal } = useFontSize();
  const { openQRCodeModal } = useQRCode();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login();
      onClose();
    } catch (e) {
      setError('Errore durante il login');
      console.error(e);
    }
    setLoading(false);
  };

  const handleLogout = async () => {
    try {
      await logout();
      onClose();
    } catch (e) {
      console.error('Logout failed', e);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="login-dropdown" ref={dropdownRef}>
      <div className="login-dropdown__content u-scale-in">
        {currentUser ? (
          <>
            <div className="login-dropdown__user-info">
              {currentUser.photoURL ? (
                <img src={currentUser.photoURL} alt="" className="login-dropdown__avatar" />
              ) : null}
              <div className="login-dropdown__user-text">
                <h3 className="login-dropdown__title">{currentUser.displayName}</h3>
                <p className="login-dropdown__text">{currentUser.email}</p>
              </div>
            </div>

            <div className="login-dropdown__divider"></div>

            <button
              className="login-dropdown__action-btn"
              onClick={() => {
                openFontSizeModal();
                onClose(); // Close dropdown when opening modal
              }}
            >
              <span className="login-dropdown__icon">📏</span>
              Calibrazione
            </button>

            <button
              className="login-dropdown__action-btn"
              onClick={() => {
                openQRCodeModal();
                onClose();
              }}
            >
              <span className="login-dropdown__icon">📱</span>
              QR Code
            </button>

            {isAdmin && (
              <button
                className="login-dropdown__action-btn"
                onClick={() => {
                  navigate('/admin-console');
                  onClose();
                }}
              >
                <span className="login-dropdown__icon">🛠️</span>
                Admin
              </button>
            )}

            <button className="login-dropdown__logout-btn" onClick={handleLogout}>
              <span className="login-dropdown__logout-icon">🚪</span>
              Esci
            </button>

            <div className="login-dropdown__divider"></div>

            <div className="login-dropdown__legal-links">
              <button
                className="login-dropdown__legal-btn"
                onClick={() => {
                  navigate('/privacy');
                  onClose();
                }}
              >
                Privacy Policy
              </button>
              <span className="login-dropdown__legal-sep">·</span>
              <button
                className="login-dropdown__legal-btn"
                onClick={() => {
                  navigate('/terms');
                  onClose();
                }}
              >
                Termini
              </button>
            </div>
          </>
        ) : (
          <>
            <h3 className="login-dropdown__title">Accedi</h3>
            <p className="login-dropdown__text">Sincronizza i tuoi progressi</p>

            {error ? <p className="login-dropdown__error">{error}</p> : null}

            <button className="login-dropdown__google-btn" onClick={handleLogin} disabled={loading}>
              <svg width="18" height="18" viewBox="0 0 48 48">
                <path
                  d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 5.1 29.6 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21c10.5 0 20-7.7 20-21 0-1.4-.2-2.7-.5-4z"
                  fill="#FFC107"
                />
                <path
                  d="M6.3 14.7l7 5.1C15.2 16 19.2 13 24 13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 5.1 29.6 3 24 3c-7.7 0-14.3 4.4-17.7 11.7z"
                  fill="#FF3D00"
                />
                <path
                  d="M24 45c5.5 0 10.4-1.8 14.2-4.9l-6.6-5.3C29.4 36.5 26.9 37 24 37c-6 0-11-4-12.9-9.5l-7 5.4C7.8 40.7 15.2 45 24 45z"
                  fill="#4CAF50"
                />
                <path
                  d="M44.5 20H24v8.5h11.8c-.6 2.5-2.2 4.7-4.4 6.2l6.6 5.3C42.5 36 45 30.5 45 24c0-1.4-.2-2.7-.5-4z"
                  fill="#1976D2"
                />
              </svg>
              {loading ? 'Entrando...' : 'Accedi con Google'}
            </button>

            <div className="login-dropdown__legal-links login-dropdown__legal-links--login">
              <span className="login-dropdown__legal-label">Accedendo accetti i nostri</span>
              <button
                className="login-dropdown__legal-btn"
                onClick={() => {
                  navigate('/terms');
                  onClose();
                }}
              >
                Termini di Servizio
              </button>
              <span className="login-dropdown__legal-sep">e la</span>
              <button
                className="login-dropdown__legal-btn"
                onClick={() => {
                  navigate('/privacy');
                  onClose();
                }}
              >
                Privacy Policy
              </button>
            </div>
          </>
        )}
      </div>
      <div className="login-dropdown__arrow"></div>
    </div>
  );
};
